export enum ChangeLanguageActionTypes {
    REQUEST = "@@account/change-language/request",
    SUCCESS = "@@account/change-language/success",
    ERROR = "@@account/change-language/error"
}

export enum GetAccountActionTypes {
    REQUEST = "@@account/get-account/request",
    SUCCESS = "@@account/get-account/success",
    ERROR = "@@account/get-account/error"
}

export enum RegisterActionTypes {
    REQUEST = "@@account/register/request",
    SUCCESS = "@@account/register/success",
    ERROR = "@@account/register/error"
}

export enum ForgotPasswordActionTypes {
    REQUEST = "@@account/forgot-password/request",
    SUCCESS = "@@account/forgot-password/success",
    ERROR = "@@account/forgot-password/error"
}

export enum ResetPasswordActionTypes {
    REQUEST = "@@account/reset-password/request",
    SUCCESS = "@@account/reset-password/success",
    ERROR = "@@account/reset-password/error"
}

export enum ChangePasswordActionTypes {
    REQUEST = "@@account/change-password/request",
    SUCCESS = "@@account/change-password/success",
    ERROR = "@@account/change-password/error"
}

export enum UpdateUserActionTypes {
    REQUEST = "@@account/update-user/request",
    SUCCESS = "@@account/update-user/success",
    ERROR = "@@account/update-user/error"
}

export enum VerifyActivationMailActionTypes {
    REQUEST = "@@account/verify-activation-mail/request",
    SUCCESS = "@@account/verify-activation-mail/success",
    ERROR = "@@account/verify-activation-mail/error"
}

export enum VerifyEmailActionTypes {
    REQUEST = "@@account/verify-email/request",
    SUCCESS = "@@account/verify-email/success",
    ERROR = "@@account/verify-email/error"
}

export enum GetIsFullProfileActivationInProgressActionTypes {
    REQUEST = "@@account/get-is-full-profile-activation-in-progress/request",
    SUCCESS = "@@account/get-is-full-profile-activation-in-progress/success",
    ERROR = "@@account/get-is-full-profile-activation-in-progress/error"
}

export enum ActivateFullProfileActionTypes {
    REQUEST = "@@account/activate-full-profile/request",
    SUCCESS = "@@account/activate-full-profile/success",
    ERROR = "@@account/activate-full-profile/error"
}

export enum RefreshProfilesActionTypes {
    REQUEST = "@@account/refresh-profiles/request",
    SUCCESS = "@@account/refresh-profiles/success",
    ERROR = "@@account/refresh-profiles/error"
}
